export const SCHOOL_GRADIENTS = [
  'linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.98) 100%)',
  'linear-gradient(135deg, rgba(255,251,245,0.98) 0%, rgba(255,255,255,0.98) 100%)',
  'linear-gradient(135deg, rgba(245,248,255,0.98) 0%, rgba(255,255,255,0.98) 100%)',
];

export const SCHOOL_ACCENTS = ['#059669', '#1F3C88', '#C48B32', '#3B6B52'];

export const isDarkColor = (value = '') => {
  const hex = String(value || '').trim();
  if (!/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(hex)) {
    return false;
  }
  const normalized =
    hex.length === 4
      ? `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`
      : hex;
  const r = parseInt(normalized.slice(1, 3), 16);
  const g = parseInt(normalized.slice(3, 5), 16);
  const b = parseInt(normalized.slice(5, 7), 16);
  const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  return luminance < 0.55;
};

export const getAccentColor = (section, fallback = '#059669') =>
  String(section?.sectionTitleColor || section?.buttonBgColor || section?.dividerColor || fallback).trim() || fallback;

export const getBodyColor = (
  section,
  darkFallback = 'rgba(255,255,255,0.84)',
  lightFallback = '#475569'
) => (isDarkColor(section?.sectionBgColor) ? darkFallback : lightFallback);

export const createPanelSx = ({
  background = SCHOOL_GRADIENTS[0],
  radius = 18,
  padding = { xs: 1.5, md: 1.75 },
  shadow = '0 18px 34px rgba(15,23,42,0.06)',
  hover = false,
  minHeight,
} = {}) => {
  const sx = {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: radius,
    background,
    border: 'none',
    boxShadow: shadow,
    p: padding,
    minHeight,
    transition: 'transform 200ms ease, box-shadow 200ms ease',
  };

  if (hover) {
    sx['&:hover'] = {
      transform: 'translateY(-2px)',
      boxShadow: '0 24px 40px rgba(15,23,42,0.1)',
    };
  }

  return sx;
};

export const createBadgeSx = (accent = '#059669', overrides = {}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.45,
  px: 0.9,
  py: 0.42,
  width: 'fit-content',
  borderRadius: 6,
  background: overrides.background || 'rgba(255,255,255,0.86)',
  border: `1px solid ${overrides.borderColor || 'rgba(203,213,225,0.86)'}`,
  color: overrides.color || accent,
  fontSize: overrides.fontSize || '0.7rem',
  fontWeight: 800,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  ...overrides,
});

export const createImageFrameSx = (accent = 'rgba(5,150,105,0.12)', radius = 18) => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: radius,
  background: 'linear-gradient(180deg, rgba(241,245,249,0.98) 0%, rgba(255,255,255,0.98) 100%)',
  boxShadow: '0 16px 28px rgba(15,23,42,0.08)',
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    background: `linear-gradient(180deg, transparent 0%, ${accent} 100%)`,
    opacity: 0.08,
  },
});

export const createEditorialImageSx = (
  objectPosition = 'center center',
  height = { xs: 220, md: 280 },
  radius = 18
) => ({
  width: '100%',
  height,
  display: 'block',
  objectFit: 'cover',
  objectPosition,
  borderRadius: radius,
});
